import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// Format number with Guinean locale (space separator, comma decimal)
export function formatNumber(num) {
  if (num == null) return '0';
  return new Intl.NumberFormat('fr-GN').format(num);
}

// Format currency
export function formatCurrency(amount, devise = 'GNF') {
  if (amount == null) return '0 GNF';
  return `${formatNumber(Math.round(amount))} ${devise}`;
}

// Format date DD/MM/YYYY
export function formatDate(dateStr) {
  if (!dateStr) return '';
  const d = new Date(dateStr);
  if (isNaN(d.getTime())) return dateStr;
  return d.toLocaleDateString('fr-FR', { day: '2-digit', month: '2-digit', year: 'numeric' });
}

// Format datetime
export function formatDateTime(dateStr) {
  if (!dateStr) return '';
  const d = new Date(dateStr);
  if (isNaN(d.getTime())) return dateStr;
  return d.toLocaleDateString('fr-FR', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' });
}

// Format time only
export function formatTime(dateStr) {
  if (!dateStr) return '';
  const d = new Date(dateStr);
  if (isNaN(d.getTime())) return dateStr;
  return d.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' });
}

// Get initials from name
export function getInitials(name) {
  if (!name) return '??';
  return name.split(' ').filter(w => w.length > 1 && w[0] === w[0].toUpperCase()).map(w => w[0]).slice(0, 2).join('');
}

// Status colors
export function getStatusColor(statut) {
  const colors = {
    'Ouvert': { bg: 'rgba(34,197,94,0.15)', text: '#22C55E', border: 'rgba(34,197,94,0.3)' },
    'En cours': { bg: 'rgba(201,162,39,0.15)', text: '#C9A227', border: 'rgba(201,162,39,0.3)' },
    'En attente': { bg: 'var(--border-color)', text: 'var(--text-secondary)', border: 'var(--border-color)' },
    'Clôturé': { bg: 'rgba(30,96,145,0.15)', text: '#5BA3D9', border: 'rgba(30,96,145,0.3)' },
    'Actif': { bg: 'rgba(34,197,94,0.15)', text: '#22C55E', border: 'rgba(34,197,94,0.3)' },
    'Terminé': { bg: 'var(--border-color)', text: 'var(--text-secondary)', border: 'var(--border-color)' },
    'Suspendu': { bg: 'rgba(245,158,11,0.15)', text: '#F59E0B', border: 'rgba(245,158,11,0.3)' },
    'Payée': { bg: 'rgba(34,197,94,0.15)', text: '#22C55E', border: 'rgba(34,197,94,0.3)' },
    'Émise': { bg: 'rgba(30,96,145,0.15)', text: '#5BA3D9', border: 'rgba(30,96,145,0.3)' },
    'Envoyée': { bg: 'rgba(201,162,39,0.15)', text: '#C9A227', border: 'rgba(201,162,39,0.3)' },
    'En retard': { bg: 'rgba(220,38,38,0.15)', text: '#DC2626', border: 'rgba(220,38,38,0.3)' },
    'Brouillon': { bg: 'var(--border-color)', text: 'var(--text-tertiary)', border: 'var(--border-color)' },
    'Annulée': { bg: 'var(--bg-tertiary)', text: 'var(--text-tertiary)', border: 'var(--border-color)' },
  };
  return colors[statut] || colors['En attente'];
}

export function getPriorityColor(priorite) {
  const colors = {
    'Critique': { bg: 'rgba(220,38,38,0.15)', text: '#DC2626', border: 'rgba(220,38,38,0.3)' },
    'Haute': { bg: 'rgba(245,158,11,0.15)', text: '#F59E0B', border: 'rgba(245,158,11,0.3)' },
    'Moyenne': { bg: 'rgba(201,162,39,0.15)', text: '#C9A227', border: 'rgba(201,162,39,0.3)' },
    'Basse': { bg: 'var(--border-color)', text: 'var(--text-secondary)', border: 'var(--border-color)' },
  };
  return colors[priorite] || colors['Moyenne'];
}

// Days remaining
export function daysRemaining(dateStr) {
  if (!dateStr) return null;
  const d = new Date(dateStr);
  const now = new Date();
  const diff = Math.ceil((d - now) / (1000 * 60 * 60 * 24));
  return diff;
}
